import React from 'react';
import { TextField, TextFieldProps } from '@mui/material';

/**
 * MobileTextField - Reusable TextField component with mobile settings styling
 * Extracted from MobileAccountSettings (appears 6+ times)
 */
function MobileTextField(props: TextFieldProps): JSX.Element {
  return (
    <TextField
      {...props}
      sx={{
        '& .MuiOutlinedInput-root': {
          borderRadius: '12px',
          '& input': {
            fontSize: '16px',
          },
          '& fieldset': {
            borderColor: '#E0E0E0',
          },
          '&:hover fieldset': {
            borderColor: '#E0E0E0',
          },
          '&.Mui-focused fieldset': {
            borderColor: '#E0E0E0',
          },
        },
        ...props.sx, // Allow override of default styles
      }}
    />
  );
}

export default MobileTextField;
